@if (activeNews().length > 0) {
  <div class="news-container">
    <div class="news-list">
      @for (news of activeNews(); track news.id) {
        <div class="news-card">
          <div class="news-header">
            <h4 class="news-card-title">{{ news.title }}</h4>
          </div>

          <p class="news-description">{{ news.description }}</p>

          <div class="news-dates">
            <div class="date-row">
              <span class="date-label">{{ 'news.startDate' | translate }}:</span>
              <span class="date-value">{{ formatDate(news.startDate) }}</span>
            </div>
            <div class="date-row">
              <span class="date-label">{{ 'news.endDate' | translate }}:</span>
              <span class="date-value">{{ formatDate(news.endDate) }}</span>
            </div>
          </div>

          @if (news.createdBy) {
            <div class="news-creator">
              <span class="creator-label">{{ 'news.createdBy' | translate }}:</span>
              <span class="creator-name">{{ news.createdBy.scdName }}</span>
            </div>
          }

          @if (news.newsType === NEWS_TYPES.GROUP_AND_TEAM) {
            <div class="news-target">
              <span class="target-label">{{ 'news.targetGroup' | translate }}:</span>
              <span class="target-info">{{ news.groupName }}</span>
            </div>
            @if (news.teamName && news.teamName !== news.groupName) {
              <div class="news-target">
                <span class="target-label">{{ 'news.targetTeam' | translate }}:</span>
                <span class="target-info">{{ news.teamName }}</span>
              </div>
            }
          } @else if (news.newsType === NEWS_TYPES.ALL_EMPLOYEES) {
            <div class="news-target">
              <span class="target-label">{{ 'news.target' | translate }}:</span>
              <span class="target-info">{{ 'news.targetAll' | translate }}</span>
            </div>
          } @else if (news.newsType === NEWS_TYPES.USER_ROLE) {
            <div class="news-target">
              <span class="target-label">{{ 'news.targetRole' | translate }}:</span>
              <span class="target-info">
                @for (roleName of news.userRoleNames; track roleName; let isLast = $last) {
                  {{ `employee.roles.${roleName}` | translate }}{{ isLast ? '' : ', ' }}
                }
              </span>
            </div>
          }
        </div>
      }
    </div>
  </div>
} @else {
  <div class="no-news">
    <p class="no-news-message">{{ 'news.noActiveNews' | translate }}</p>
  </div>
}
